var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-phone.5dcbb33a.png","uri@2x": __webpack_public_path__ + "icon-phone.8ce8e730.png","uri@3x": __webpack_public_path__ + "icon-phone.3394a137.png",
    width: 21,
    height: 20
});